import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="max-w-content mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
      <p className="font-heading font-black text-6xl md:text-8xl text-primary-100 select-none">
        404
      </p>
      <h1 className="mt-4 font-heading font-black text-2xl md:text-3xl text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-500">
        抱歉，你访问的页面不存在或已被移除。
      </p>
      <p className="mt-1 text-xs text-foreground-400 break-all">
        {location.pathname}
      </p>
      <div className="mt-8 flex items-center justify-center flex-wrap gap-3">
        <Link
          to="/"
          className="h-11 px-6 flex items-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="h-11 px-6 flex items-center gap-2 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 whitespace-nowrap cursor-pointer hover:border-accent-300 hover:text-accent-600 transition-colors"
        >
          <i className="ri-movie-2-line" />
          浏览电影频道
        </Link>
      </div>
    </div>
  );
}